export default __webpack_public_path__ + "static/media/bg-tools.54c465cf.jpg";